'use es6';

import unified from './unified';
import { SEQUENCE_SENDER_SCORE } from '../../../constants/dataTypes';
import { getFilterByProperty } from '../../../config/filters/functions';
import { fromJS } from 'immutable';
function generateSequenceSenderScoreDrilldown(report, ...rest) {
  return unified.generate(report, ...rest).then(drilled => drilled.setIn(['config', 'metrics'], report.getIn(['config', 'metrics'])).update('name', name => name && name.includes('/') ? name.split('/')[1] : name));
}
const isSupportedColumn = (report, ...args) => {
  return report.getIn(['config', 'dataType']) === SEQUENCE_SENDER_SCORE && unified.isSupportedColumn(report, ...args);
};
export default {
  isSupported: (report, __dataTypeModule) => {
    const isDrilldown = Boolean(getFilterByProperty(fromJS(report.get('config')), 'd1'));
    return report.getIn(['config', 'dataType']) === SEQUENCE_SENDER_SCORE && !isDrilldown;
  },
  isSupportedColumn,
  generate: generateSequenceSenderScoreDrilldown
};